'use client';

import {
  type DehydratedState,
  HydrationBoundary,
  QueryClientProvider,
} from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { getQueryClient } from './get-query-provider';

// Conditionally load DevTools only in the browser & only in development
const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? dynamic(() => import('@tanstack/react-query-devtools').then((m) => m.ReactQueryDevtools), {
        ssr: false,
      })
    : () => null;

export function QueryProvider({
  children,
  dehydratedState,
  staleTime,
}: {
  children: React.ReactNode;
  dehydratedState?: DehydratedState;
  staleTime?: number;
}) {
  const queryClient = getQueryClient({ staleTime });

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
